import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Tag } from '../../models/common/tag.model';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import TagSelectorView from './tag-selector.component.html';

@Component({
  selector: 'tag-selector',
  template: TagSelectorView
})
export class TagSelectorComponent implements OnInit, OnChanges {
  @Input() tags: Tag[] = [];
  @Input() selectedTags: Tag[] = [];
  @Output() selectedTagsChange: EventEmitter<Tag[]> = new EventEmitter<Tag[]>();

  filteredTags: Tag[] = [];

  constructor() { }

  ngOnInit() {
    // Initialize filteredTags with all available tags
    this.filteredTags = [...this.tags];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tags']) {
      this.filteredTags = [...(this.tags || [])];
    }
  }

  search(event: AutoCompleteCompleteEvent) {
    const query = (event?.query || '').toLowerCase();
    this.filteredTags = this.tags.filter(tag => {
      return typeof(tag.title) === 'string' && tag.title.toLowerCase().includes(query);
    });
  }

  notify(event: any) {
    this.selectedTagsChange.emit(this.selectedTags);
  }

  removeTag(tag: Tag) {
    this.selectedTags = this.selectedTags.filter(t => t.id !== tag.id);
    this.selectedTagsChange.emit(this.selectedTags);
  }
}
